import React, { useMemo } from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { getIcon } from '@next-nx/utils/icons'
import { WContainer, WImage } from '@next-nx/shared-ui/atoms'
import styles from './VantaggiSection.module.sass'

interface Props {
  item: MenuItemType
  color?: 'light' | 'dark' | 'grey'
  imagePos?: 'top' | 'bottom'
  className?: string
}

const VantaggiSection = (props: Props) => {
  const { item = undefined, color = 'light', imagePos = 'top', className = '' } = props

  const imageBox = useMemo(
    () =>
      item && (
        <WImage
          src={item.image}
          alt={item.name}
          title={item.name}
          maxWidth={421}
          maxHeight={514}
          layout="intrinsic"
        />
      ),
    [item?.image]
  )

  return item ? (
    <div
      className={`${styles.root} ${styles[`root--${color}`]} ${
        styles[`root--image-${imagePos}`]
      } ${className}`}
    >
      <WContainer>
        <div className={styles.content}>
          <p className={styles.title}>{item.name}</p>
          {item.children?.edges?.length && (
            <div className={styles.list}>
              {item.children.edges
                .map((x) => x.node)
                .map((x) => (
                  <div className={styles.item} key={x.pk}>
                    {!!getIcon(x.style) && (
                      <div className={styles.itemIcon}>{getIcon(x.style)}</div>
                    )}
                    {!!x.name && <p className={styles.itemTitle}>{x.name}</p>}
                    {!!x.description && (
                      <div
                        className={styles.itemDescription}
                        dangerouslySetInnerHTML={{ __html: x.description }}
                      />
                    )}
                  </div>
                ))}
            </div>
          )}
        </div>
      </WContainer>
      <div className={styles.imageBox}>{imageBox}</div>
    </div>
  ) : (
    <></>
  )
}

export default VantaggiSection
